// There are more complex / safer ways to check for the user's OS; this is a lightweight method
// that doesn't require additional dependencies.
export const inWindowsOS =
    navigator?.userAgent?.match === undefined
        ? false
        : navigator.userAgent.match(/Windows/) !== null;
